/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-shadow */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-unresolved */
/* eslint-disable security/detect-object-injection */
import moment from "moment";
import { medicalQuestionExcludedQuestionID, partners } from "src/config/constant";
import * as yup from "yup";
import { FormikProps } from "formik";
import regex from "src/helpers/regex";
import { familyMedicalData, MedicalQuestionnaireAPIData } from "./interfaces";
import { constructValidationSchema } from "./MedicalAndLifeStyle";

const loanPageHelperText = {
  moratoriumPeriod: "Upto 84 Months",
  deathSumAssured: "Including Premium, if funded by the financial institution",
  totalPayment:
    "Instalment premium payable including GST & cess with respect to member to be insured",
  existingLifeCover: (partnerId: string) => {
    switch (partnerId) {
      case partners.JIO:
        return "Do you have any existing (inforce) or pending life/critical illness/credit life insurance cover with AFLI or any other insurer or has any of your insurance application or reinstatement application ever been declined, postponed or any policy accepted with extra premium or modified terms? if yes to any of the above, provide complete details in the Addendum Form.";
      default:
        return "Please provide the details of existing life / critical illness / credit life cover details OR pending / simultaneous insurance cover for fresh / lapsed policies OR / any declined / postponed / rated up / null & void / not taken up on life assured / joint life in the below table.";
    }
  },
  info: "* Please indicate if risk is accepted at ordinary rates or with extra mortality rate or declined",
  joinInfo: "Do you want to add Joint Life Addendum ?",
  customerDeclaration:
    "In case of Master Policy Holder is other than those stated above the death benefit is directly paid to the beneficiary of the insured member. I hereby declare and warrant on my behalf that all the answers given in response to the questions here in above and the statements made in this form or otherwise in support of this application are true, correct and complete in all respects, and there is no other information material to this application that has not been disclosed. I further agree that if after the date of submission of the application but before the issue of Certificate of Insurance there is (i) any change in my occupation or any adverse circumstances connected with my financial position or my health or (ii) if a proposal for assurance or an application for revival of a policy on my life made to any other insurer is withdrawn, deferred, declined or accepted at an increased premium or subject to a lien or on terms other than as proposed, I shall forthwith intimate the same to the Company in writing. I consent, authorise and direct any doctor, hospital, or employer to disclose to the Company any information relating to my present state of health and my past health history. I agree and declare that in event of me being medically examined, the answers given by me to the medical examiner acting on behalf of Company shall be deemed to be part of the statements and answers given in relation to this application and they shall form basis of this application. I agree that the risk cover proposed under the master policy may not commence till the Company accepts this application and communicates to me the commencement of risk by way of certificate of insurance except to the extent as specifically mentioned in the master policy document.",
  customerDeclarationSubPart_1:
    "I declare that the premiums paid have not been generated from the proceeds of any criminal activities/ offences and I shall abide by and conform to the Prevention of Money Laundering Act, 2002 and amendments made therein or any other applicable laws. I understand that in case of fraud or misstatement by me , action will be initiated as per provisions of section 45 of the insurance act 1938 as amended from time to time.",
  customerDeclarationSubPart_2:
    "I authorise Ageas Federal to use my mobile number/email ID as mentioned above for sending alerts relating to this enrolment and resulting COI. I authorise the master policyholder to pay the premium payable on my behalf/collected from me and disclose to the insurer such particulars as they may require including the details given above and changes to the same such as loan details, personal detals.",
  customerDeclarationSubPart_3:
    "I authorize the Master Policyholder to provide information to Ageas Federal Life Insurance Company Ltd. in electronic mode regarding my personal details related to name, date of birth, gender, address, occupation, details regarding Know Your Customer (KYC), Prevention of Money Laundering Act related documents, and other material information as required for issuance of the cover. I authorise Ageas Federal to also send me the Policy Document electronically.",
  mefSupportedFile: [".svg", ".png", ".pdf", ".jpg", ".gif", ".jpeg"],
  mefUploadIRMSupportedFiles: [".pdf", ".png", ".jpg", ".jpeg", ".csv", ".xlsx", ".doc", ".docx"]
};

const BE_KEY_MAPPING = {
  coverOptions: {
    reducing: "Reducing Death Benefit Option",
    level: "Level Death Benefit Option"
  },
  premiumFunding: {
    bank: "Bank/Lending Institution Funded",
    self: "Self Funded"
  },
  premiumPaymentTerm: {
    1: "Single"
  }
};
const OPTIONS = {
  title: ["Mr", "Mrs.", "Ms.", "Dr.", "Others"],
  gender: ["Male", "Female", "Transgender"],
  nationality: ["Indian", "Non Resident Indian (NRI)", "Person of Indian Origin (PIO)"],
  maritalStatus: ["Married", "Single", "Widow(er)", "Divorcee"],
  educationQualification: [
    "Graduate & Above",
    "12th Passed",
    "10 Passed",
    "Below 10th",
    "Uneducated",
    "Diploma"
  ],
  occupation: [
    "Professional",
    "Business Owner",
    "Housewife",
    "Retired/Pensioner",
    "Agriculturist",
    "Self Employed",
    "Salaried",
    "Student",
    "Others"
  ],
  natureOfWork: ["Administrative", "Skilled-Manual", "Unskilled-Manual"],
  lifeCoverOption: Object.values(BE_KEY_MAPPING.coverOptions),
  loanType: ["Home Loans", "Plot Loans", "Loan Against Property"],
  coverOptions: ["Single Life Cover", "Joint Life Cover", "Proportionate Cover"],
  premiumPaymentTerm: ["Single"],
  premiumFunding: Object.values(BE_KEY_MAPPING.premiumFunding),
  paymentMethod: ["Cheque", "Demand Draft", "Direct Debit"],
  premiumMode: ["Single"],
  moratoriumPeriod: Array.from({ length: 8 }, (_, index) => index.toString()),
  loanTerm: Array.from({ length: 21 }, (_, index) => (index + 10).toString()),
  coverTerm: Array.from({ length: 30 }, (_, index) => (index + 1).toString()),
  electronicAccount: ["Yes", "No"],
  typeOfLoan: ["NEW", "EXISTING"],
  bankDistributorName: ["IDBI", "FEDERAL"]
};

const addOrdinalSuffix = (number: number) => {
  if (number === 0) return "";
  const lastDigit = number % 10;
  const lastTwoDigits = number % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
    return `${number}th`;
  }

  switch (lastDigit) {
    case 1:
      return `${number}st`;
    case 2:
      return `${number}nd`;
    case 3:
      return `${number}rd`;
    default:
      return `${number}th`;
  }
};

function addKeyValueAfterKey(obj: any, keyToAddAfter: string, newObj: Object) {
  return Object.keys(obj).reduce((acc: any, key: any) => {
    // eslint-disable-next-line security/detect-object-injection
    acc[key] = obj[key];
    if (key === keyToAddAfter) {
      // eslint-disable-next-line no-return-assign, prefer-destructuring
      Object.entries(newObj).map((entry) => (acc[entry[0]] = entry[1]));
    }
    return acc;
  }, {});
}

const calcAgeFromToday = (dob: string) => {
  const currentDate = moment();
  const dobDate = moment(dob, "DD/MM/YYYY");
  const age = currentDate.diff(dobDate, "years");
  return age;
};

const findKeysByValue = (obj: any, targetValue: string | undefined): string =>
  Object.keys(obj)
    .filter((key) => obj[key] === targetValue)
    .toString();

const mapTouched: any = (values: any) => {
  if (Array.isArray(values)) {
    return values?.map((item: any) => mapTouched(item));
  }
  if (typeof values === "object" && values !== null) {
    const touched: Record<string, any> = {};
    for (const key in values) {
      touched[key] = mapTouched(values[key]);
    }
    return touched;
  }
  return true;
};

const concatDetails = (address = {}) => {
  const truthyValues = Object.values(address)?.filter(Boolean);
  return truthyValues.join(", ");
};

const checkMedicalField = (values: Record<string, any>) => {
  const {
    medicalHealth,
    smoker,
    alcohol,
    diabetes,
    stroke,
    asthma,
    epilepsy,
    liverDisease,
    kidneyDisease,
    bloodDisorder,
    tumor,
    anxiety,
    aids,
    familyHealthHistory,
    drugs,
    disability,
    gyneComplications,
    pregnant,
    indigestion,
    thyroid,
    arthritis,
    diabetesAndSugar,
    bloodPressureHeartAttack,
    strokeParalysis,
    asthamaTuberculosis,
    kidneyStoneBloodUrine,
    anaemia,
    cancerTumor,
    anxietyDepression,
    otherDisease,
    occupationEnquiry,
    existingApplication,
    familyHealth,
    hospitalisation,
    majorDisorder,
    underTreatment,
    heartDisease,
    strokeTIA,
    lungDisease,
    highCholesterol,
    hivAidsSTI,
    congenitalDefect,
    genitourinaryHearingVisionDisorder,
    paralysis,
    mentalPsychiatricDisorder,
    brainNervousSystemDisorder,
    muscleBoneJointDisorder,
    bloodCirculatoryDisorder,
    thyroidDisorder,
    chronicDigestiveDisorder,
    endocrineDisorder,
    anyOtherDisease,
    weightLossProgram,
    investigateCheckups,
    personalConsumptionSmoking,
    personalConsumptionTobacco,
    personalConsumptionAlcohol,
    personalConsumptionDrugNarcotics,
    isOccupationHazardious,
    mines,
    explosives,
    radiation,
    corrosiveChemicals,
    hobbyQuery,
    aviation,
    diving,
    mountaineering,
    seaDiving,
    motorRacing,
    bungeeJumping,
    familyHealthQuery,
    femaleOrientedQuery,
    femalePregnanacyQuery
  } = values;
  return [
    medicalHealth,
    smoker,
    alcohol,
    diabetes,
    stroke,
    asthma,
    epilepsy,
    liverDisease,
    kidneyDisease,
    bloodDisorder,
    tumor,
    anxiety,
    aids,
    familyHealthHistory,
    drugs,
    disability,
    gyneComplications,
    pregnant,
    indigestion,
    thyroid,
    arthritis,
    diabetesAndSugar,
    bloodPressureHeartAttack,
    strokeParalysis,
    asthamaTuberculosis,
    kidneyStoneBloodUrine,
    anaemia,
    cancerTumor,
    anxietyDepression,
    otherDisease,
    occupationEnquiry,
    existingApplication,
    familyHealth,
    hospitalisation,
    majorDisorder,
    underTreatment,
    heartDisease,
    strokeTIA,
    lungDisease,
    highCholesterol,
    hivAidsSTI,
    congenitalDefect,
    genitourinaryHearingVisionDisorder,
    paralysis,
    mentalPsychiatricDisorder,
    brainNervousSystemDisorder,
    muscleBoneJointDisorder,
    bloodCirculatoryDisorder,
    thyroidDisorder,
    chronicDigestiveDisorder,
    endocrineDisorder,
    anyOtherDisease,
    weightLossProgram,
    investigateCheckups,
    personalConsumptionSmoking,
    personalConsumptionTobacco,
    personalConsumptionAlcohol,
    personalConsumptionDrugNarcotics,
    isOccupationHazardious,
    mines,
    explosives,
    radiation,
    corrosiveChemicals,
    hobbyQuery,
    aviation,
    diving,
    mountaineering,
    seaDiving,
    motorRacing,
    bungeeJumping,
    familyHealthQuery,
    femaleOrientedQuery,
    femalePregnanacyQuery
  ].filter(Boolean).length;
};

const getFullName = (...args: (string | undefined)[]) => args?.filter(Boolean)?.join(" ");

const findValueByLabel = (
  obj: Record<string, { label: string; value: string }[]>,
  targetLabel: string
): string | undefined =>
  Object.entries(obj)
    .flatMap(([, values]) => values)
    .find((item) => item?.label === targetLabel)?.value;

export const familyMedicalHistory = {
  familyPersonName: "",
  familyRelation: "",
  status: "Alive",
  sufferingAge: "",
  ageOfDeath: "",
  presentStateOfHealth: "",
  causeDeath: ""
};

const constructFormikProps = (
  questionnaire: MedicalQuestionnaireAPIData.QuestionnaireReducer,
  { gender, sumAssured, age }: Record<string, any>,
  apiData: Record<string, any>
) => {
  const properties = Object.entries(questionnaire || {})?.reduce(
    (acc: Record<string, any>, [key, value]) => {
      acc.initialValues[key] = apiData?.[key] ?? value?.description?.defaultValue ?? "";
      acc.validationSchema[key] = constructValidationSchema(value?.description as any);
      value?.description?.subQuestions?.questions?.forEach((subQ: any) => {
        if (subQ?.key) {
          acc.initialValues[subQ.key] = apiData?.[subQ.key] ?? subQ?.defaultValue ?? "";
          acc.validationSchema[subQ.key] = constructValidationSchema(
            subQ?.validation as any,
            {
              showIf: {
                ...((value?.description?.subQuestions?.showIf || {}) as any),
                ...(subQ?.showIf || {})
              }
            },
            subQ?.logical || value?.description?.subQuestions?.logical
          );
        }
        subQ?.subQuestions?.questions?.forEach((q: any) => {
          if (q?.key) {
            acc.initialValues[q?.key] = apiData?.[q?.key] ?? q?.defaultValue ?? "";
            acc.validationSchema[q?.key] = constructValidationSchema(
              q?.validation as any,
              {
                showIf: { ...subQ?.subQuestions?.showIf, ...(q?.showIf || {}) }
              },
              subQ?.subQuestions?.logical
            );
          }
        });
        (subQ?.options as MedicalQuestionnaireAPIData.CheckboxOptions[])?.forEach((option) => {
          if (option?.key) {
            acc.initialValues[option.key] = apiData?.[option.key] ?? option?.defaultValue ?? "";
            acc.validationSchema[option.key] = constructValidationSchema(
              option as any,
              {
                showIf: {
                  ...((value?.description?.subQuestions?.showIf || {}) as any),
                  ...((subQ?.showIf || {}) as any),
                  ...(option?.showIf || {})
                }
              },
              subQ?.logical
            );
          }
          option?.leadingQuestions?.forEach((leadingQuestion: any) => {
            if (leadingQuestion?.key) {
              acc.initialValues[leadingQuestion.key] =
                apiData?.[leadingQuestion.key] ?? leadingQuestion?.defaultValue ?? "";
              acc.validationSchema[leadingQuestion.key] = constructValidationSchema(
                leadingQuestion?.validation as any,
                {
                  showIf: (leadingQuestion?.showIf || {}) as any
                },
                leadingQuestion?.logical
              );
            }
          });
        });
      });
      return acc;
    },
    {
      initialValues: {
        version: 3,
        gender,
        sumAssured,
        age,
        height: {
          centimeter: {
            cm: apiData?.height?.centimeter?.cm ?? ""
          },

          inchFeet: {
            inches: apiData?.height?.inchFeet?.inches ?? "",
            feet: apiData?.height?.inchFeet?.feet ?? ""
          }
        },
        weight: apiData?.weight ?? "",
        measurement: apiData?.measurement ?? "cm",
        familyMedicalHistory: [familyMedicalHistory]
      },
      validationSchema: {}
    }
  );
  Object.assign(properties?.initialValues, {
    familyMedicalHistory: apiData?.familyMedicalHistory || [familyMedicalHistory]
  });
  return {
    initialValues: properties?.initialValues,
    validationSchema: yup.object().shape({
      ...properties?.validationSchema,
      familyMedicalHistory: familyMedicalHistoryValidation(),
      measurement: yup.string(),
      weight: yup
        .string()
        .required("Required")
        .matches(regex.numericNotZero, "Invalid")
        .max(3, "max 3 digit only"),
      height: yup.object().shape({
        centimeter: yup.object().shape({
          cm: yup
            .string()
            .test("measurement", "Required", (value: any, helpers) => {
              const { measurement } = helpers.options?.context || {};
              if (measurement === "cm" && !value) {
                return false;
              }
              return true;
            })
            .max(3, "max 3 digit")
            .matches(regex.numericNotZero, "Invalid Height")
        }),
        inchFeet: yup.object().shape({
          inches: yup
            .string()
            .test("measurement-inches", "Required", (value: any, helpers) => {
              const { measurement } = helpers.options?.context || {};
              if (measurement !== "cm" && !value) {
                console.log("inche");
                return false;
              }
              return true;
            })
            .matches(regex.oneToTwelveRange, "Invalid")
            .max(2, "max 2 digit"),
          feet: yup
            .string()
            .test("measurement-feet", "Required", (value: any, helpers) => {
              const { measurement } = helpers.options?.context || {};
              if (measurement !== "cm" && !value) {
                console.log("feet");
                return false;
              }
              return true;
            })
            .matches(regex.numericNotZero, "Invalid")
            .max(1, "max 1 digit")
        })
      })
    })
  };
};

const getConditionValue = (obj: Record<string, any>, formik: FormikProps<any>, logical = "AND") => {
  const dataValue = Object?.entries(obj || {})?.reduce((acc: boolean[], [key, value]) => {
    if (typeof value === "object") {
      if (
        Number(formik?.values?.[key] || 0) >= value?.min &&
        Number(formik?.values?.[key] || 0) <= value?.max
      ) {
        acc?.push(true);
      } else acc?.push(false);
    } else if (formik?.values?.[key] === value) acc?.push(true);
    else acc?.push(false);
    return acc;
  }, []);
  return logical === "OR" ? dataValue?.some((ele) => ele) : dataValue?.every((ele) => ele);
};

const isMedicalResponseNo = (medicalValues: Record<string, any>) => {
  const booleanValues = Object.entries(medicalValues)
    ?.filter(
      ([key, value]) =>
        !medicalQuestionExcludedQuestionID?.includes(key) && typeof value === "boolean"
    )
    ?.map((e) => e[1]);
  const anyTruthy = booleanValues?.some((ele) => ele === true);
  return !anyTruthy;
};

const showNewVersionUW = (member: Record<string, any>) => {
  if (member?.medicalAndLifeStyle) {
    if (!member?.medicalAndLifeStyle?.version) return false;
    return true;
  }
  return true;
};

const resetFormikState = (questionnaire: Record<string, any>, formik: FormikProps<any>) => {
  Object.values(questionnaire)?.forEach((question) => {
    const baseCondition =
      question?.description?.condition &&
      !getConditionValue(question?.description?.condition, formik, question?.description?.logical);
    question?.description?.subQuestions?.questions?.forEach((subQ: any) => {
      const rootLevelCondition =
        question?.description?.subQuestions?.showIf &&
        !getConditionValue(
          question?.description?.subQuestions?.showIf!,
          formik,
          question?.description?.subQuestions?.logical
        );
      if (
        baseCondition ||
        rootLevelCondition ||
        (subQ?.showIf && !getConditionValue(subQ?.showIf!, formik, subQ?.logical))
      ) {
        if (subQ?.key) formik?.setFieldValue(subQ?.key, subQ?.defaultValue ?? "");
      }

      subQ?.subQuestions?.questions?.forEach((q: any) => {
        if (
          subQ?.subQuestions?.showIf &&
          !getConditionValue(subQ?.subQuestions?.showIf, formik, subQ?.subQuestions?.logical)
        )
          formik?.setFieldValue(q?.key, q?.defaultValue ?? "");
      });

      subQ?.options?.forEach((option: any) => {
        if (rootLevelCondition && !getConditionValue(option?.showIf!, formik, option?.logical)) {
          if (option?.key) formik?.setFieldValue(option?.key, option?.defaultValue ?? "");
        }
        option?.leadingQuestions?.forEach((leadingQuestion: any) => {
          if (
            leadingQuestion?.showIf &&
            !getConditionValue(leadingQuestion?.showIf, formik, option?.logical)
          ) {
            if (leadingQuestion?.key)
              formik?.setFieldValue(leadingQuestion?.key, leadingQuestion?.defaultValue ?? "");
          }
        });
      });
    });
  });
};

const familyMedicalHistoryValidation = () =>
  yup.array().when("1001", {
    is: true,
    then: (schema) =>
      schema.of(
        yup.object().shape<Record<keyof familyMedicalData, yup.AnySchema>>({
          sufferingAge: yup
            .string()
            .when("status", ([status], schema) =>
              status === "Alive"
                ? schema
                    .required("Age is Required")
                    .matches(regex.digits, "Invalid Age")
                    .max(2, "Maximum 2 characters allowed")
                : schema
                    .notRequired()
                    .matches(regex.digits, "Invalid Age")
                    .max(2, "Maximum 2 characters allowed")
            ),
          ageOfDeath: yup
            .string()
            .when("status", ([status], schema) =>
              status === "Deceased"
                ? schema
                    .required("Age is Required")
                    .matches(regex.digits, "Invalid Age")
                    .max(2, "Maximum 2 characters allowed")
                : schema
                    .notRequired()
                    .matches(regex.digits, "Invalid Age")
                    .max(2, "Maximum 2 characters allowed")
            ),
          presentStateOfHealth: yup
            .string()
            .when("status", ([status], schema) =>
              status === "Alive"
                ? schema.required("Present State is Required")
                : schema.notRequired()
            ),
          familyPersonName: yup
            .string()
            .required("Name is Required")
            // .matches(regex.alphabetWithSpace, "Only alphabets allowed")
            .matches(regex.fullName, "Invalid Name Of Person")
            .max(60, "Maximum 60 characters allowed"),
          familyRelation: yup.string().required("Family Relation is required"),
          status: yup.string().required("Status is required"),
          causeDeath: yup
            .string()
            .when("status", ([status], schema) =>
              status === "Deceased"
                ? schema.required("Cause of death is Required")
                : schema.notRequired()
            )
        })
      ),
    otherwise: (schema) => schema.notRequired()
  });

export {
  loanPageHelperText,
  OPTIONS,
  BE_KEY_MAPPING,
  addOrdinalSuffix,
  addKeyValueAfterKey,
  calcAgeFromToday,
  findKeysByValue,
  mapTouched,
  concatDetails,
  checkMedicalField,
  getFullName,
  findValueByLabel,
  constructFormikProps,
  getConditionValue,
  isMedicalResponseNo,
  showNewVersionUW,
  resetFormikState
};
